<template>
  <section class="section" id="users-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <users-title @get-blocked-users="getBlockedUsers" />

      <block-user @get-blocked-users="getBlockedUsers" />
      <br />

      <blocked-users-table />
    </div>
  </section>
</template>

<script>
import { common } from "../../mixins/common";
import usersTitle from "./UsersTitle";
import blockUser from "./BlockUser";
import blockedUsersTable from "./BlockedUsersTable";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false
    };
  },

  components: {
    usersTitle,
    blockUser,
    blockedUsersTable
  },

  methods: {
    getBlockedUsers() {
      this.isLoading = true;
      this.$store
        .dispatch("getBlockedUsers")
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  mounted() {
    this.getBlockedUsers();
  }
};
</script>

<style scoped>
#users-panel {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
</style>
